interface Props {
  size?: number;
  className?: string;
  fill?: string;
}

export function Upload(props: Props) {
  const { size = 31, className } = props;
  return (
    <svg
      width={size}
      className={className}
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5 13V23C26.5 24.1046 25.6046 25 24.5 25H6.5C5.39543 25 4.5 24.1046 4.5 23V13"
        stroke="white"
        strokeLinecap="round"
      />
      <path d="M18.5 8L15.5 5" stroke="white" strokeLinecap="round" />
      <path d="M12.5 8L15.5 5" stroke="white" strokeLinecap="round" />
      <path d="M15.5 6L15.5 18.5" stroke="white" strokeLinecap="round" />
    </svg>
  );
}

export function Search(props: Props) {
  const { size = 30, fill = "#FFFFFF", className } = props;
  return (
    <>
      <svg
        width={size}
        className={className}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8889 13.4444C20.8889 17.5559 17.5559 20.8889 13.4444 20.8889C9.33299 20.8889 6 17.5559 6 13.4444C6 9.33299 9.33299 6 13.4444 6C17.5559 6 20.8889 9.33299 20.8889 13.4444ZM18.4694 20.2317C17.0653 21.273 15.3268 21.8889 13.4444 21.8889C8.78071 21.8889 5 18.1082 5 13.4444C5 8.78071 8.78071 5 13.4444 5C18.1082 5 21.8889 8.78071 21.8889 13.4444C21.8889 15.8648 20.8706 18.0474 19.239 19.5871L24.354 24.7021C24.5492 24.8973 24.5492 25.2139 24.354 25.4092C24.1587 25.6044 23.8421 25.6044 23.6469 25.4092L18.4694 20.2317Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export function UpploadBackArrow(props: Props) {
  const { size = 30, className } = props;
  return (
    <>
      <svg
        width={size}
        className={className}
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" fill="white" fillOpacity="0.01" />
        <path d="M10 11L6 15" stroke="white" strokeLinecap="round" />
        <path d="M10 19L6 15" stroke="white" strokeLinecap="round" />
        <path d="M7 15H24" stroke="white" strokeLinecap="round" />
      </svg>
    </>
  );
}

export function Spin(props: Props) {
  return (
    <>
      <svg
        aria-hidden="true"
        className="inline w-4 h-4 ml-2 text-gray-200 animate-spin dark:text-gray-600 fill-memod-green-base"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </>
  );
}

export function Zoom(props: Props) {
  const { size = 31, className } = props;
  return (
    <svg
      width={size}
      className={className}
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="30" height="30" rx="15" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5557 13.5278C19.5557 16.5808 17.0808 19.0557 14.0278 19.0557C10.9749 19.0557 8.5 16.5808 8.5 13.5278C8.5 10.4749 10.9749 8 14.0278 8C17.0808 8 19.5557 10.4749 19.5557 13.5278ZM18.2767 18.4838C17.1348 19.4636 15.6505 20.0557 14.0278 20.0557C10.4226 20.0557 7.5 17.1331 7.5 13.5278C7.5 9.92261 10.4226 7 14.0278 7C17.6331 7 20.5557 9.92261 20.5557 13.5278C20.5557 15.1505 19.9636 16.6348 18.9838 17.7767L23.5204 22.3133C23.7156 22.5085 23.7156 22.8251 23.5204 23.0204C23.3251 23.2156 23.0085 23.2156 22.8133 23.0204L18.2767 18.4838Z"
        fill="#3A3A3C"
      />
      <path
        d="M14 16C13.724 16 13.5 15.8215 13.5 15.6015V11.3985C13.5 11.1785 13.724 11 14 11C14.276 11 14.5 11.1785 14.5 11.3985V15.6015C14.5 15.8215 14.276 16 14 16Z"
        fill="#3A3A3C"
      />
      <path
        d="M16.5 13.5C16.5 13.776 16.3215 14 16.1015 14L11.8985 14C11.6785 14 11.5 13.776 11.5 13.5C11.5 13.224 11.6785 13 11.8985 13L16.1015 13C16.3215 13 16.5 13.224 16.5 13.5Z"
        fill="#3A3A3C"
      />
    </svg>
  );
}

export function Unsplash(props: Props) {
  const { size = 31, className } = props;
  return (
    <svg
      width={size}
      className={className}
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.4995 13.9551H18.8356V18.9778H12.164V13.9551H6.5V24.0006H24.4995V13.9551Z" stroke="#EBEBF5" />
      <path d="M18.8204 6H12.1641V11.0228H18.8204V6Z" stroke="#EBEBF5" />
    </svg>
  );
}

export function ImageUpload(props: Props) {
  const { size = 184, className } = props;
  return (
    <svg
      width={size}
      className={className}
      height="119"
      viewBox="0 0 184 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M120 118C120 99.2224 106.344 84 89.5 84C72.6563 84 59 99.2224 59 118H120Z" fill="#EAEAEA" />
      <path d="M184 118C184 94.8041 167.433 76 147 76C126.567 76 110 94.8041 110 118H184Z" fill="#D7D9DB" />
      <path
        d="M61.8176 113.73L60.8356 118H10.1635L9.18239 113.73C8.94142 112.682 8.9392 111.592 9.17588 110.543C9.41256 109.494 9.88204 108.512 10.5494 107.67C11.2167 106.828 12.0646 106.148 13.0301 105.68C13.9955 105.213 15.0536 104.97 16.1255 104.97C16.5177 104.972 16.9034 104.869 17.2435 104.673C17.5836 104.477 17.8661 104.194 18.0624 103.853C18.2587 103.512 18.3619 103.125 18.3615 102.731C18.3611 102.338 18.2572 101.951 18.0603 101.611L14.0039 94.5351C13.474 93.611 13.1567 92.5798 13.075 91.5168C12.9934 90.4538 13.1496 89.3859 13.5321 88.3913C13.9146 87.3967 14.5138 86.5005 15.2859 85.7683C16.0579 85.0361 16.9833 84.4865 17.9942 84.1595L23.793 82.2837C24.1207 82.1777 24.4195 81.997 24.6661 81.7559C24.9128 81.5148 25.1005 81.2197 25.2147 80.8936C25.3288 80.5676 25.3664 80.2195 25.3243 79.8765C25.2822 79.5335 25.1617 79.2049 24.9722 78.9164L22.9232 75.8029C20.2885 71.7936 22.2629 66.3677 26.8514 65.0079L29.1012 64.345C29.6461 64.1829 30.1089 63.8184 30.3954 63.3259C30.682 62.8333 30.7707 62.2496 30.6436 61.6936L29.505 56.7497C29.2969 55.8464 29.2891 54.9082 29.4823 54.0016C29.6755 53.095 30.0649 52.2421 30.623 51.5033C31.181 50.7645 31.894 50.1579 32.7116 49.7265C33.5291 49.295 34.4311 49.0493 35.3538 49.0066V49H35.6472V49.0066C36.5698 49.0493 37.4718 49.295 38.2894 49.7265C39.1069 50.1579 39.8199 50.7645 40.378 51.5033C40.936 52.2421 41.3254 53.095 41.5186 54.0016C41.7118 54.9082 41.7041 55.8464 41.4959 56.7497L40.3583 61.6936C40.2309 62.2496 40.3196 62.8334 40.6062 63.326C40.8927 63.8187 41.3557 64.1831 41.9006 64.345L44.1496 65.0079C48.7399 66.3705 50.7134 71.7964 48.0777 75.8029L46.0316 78.9164C45.8418 79.2048 45.7212 79.5334 45.679 79.8765C45.6368 80.2195 45.6743 80.5677 45.7885 80.8938C45.9027 81.2199 46.0905 81.5151 46.3372 81.7562C46.584 81.9973 46.883 82.1778 47.2108 82.2837L53.0086 84.1595C54.0195 84.4865 54.9449 85.0362 55.7169 85.7683C56.489 86.5005 57.0882 87.3967 57.4708 88.3912C57.8534 89.3858 58.0097 90.4536 57.9282 91.5167C57.8467 92.5797 57.5296 93.6109 56.9999 94.5351L52.9435 101.611C52.7465 101.951 52.6426 102.338 52.6422 102.732C52.6419 103.126 52.7452 103.512 52.9416 103.853C53.138 104.194 53.4207 104.477 53.7609 104.673C54.1011 104.869 54.4869 104.972 54.8793 104.97C55.9507 104.971 57.0082 105.214 57.9731 105.682C58.9379 106.149 59.7853 106.83 60.4521 107.671C61.1189 108.513 61.588 109.495 61.8244 110.544C62.0608 111.593 62.0585 112.682 61.8176 113.73Z"
        fill="#979797"
      />
      <path d="M37 118C37 107.507 28.717 99 18.5 99C8.28295 99 0 107.507 0 118H37Z" fill="#D7D9DB" />
      <path
        d="M39.1481 102.035V117.669"
        stroke="white"
        strokeWidth="0.832223"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.7829 107.441L39.1481 110.858"
        stroke="white"
        strokeWidth="0.832223"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.1483 117.669L34.339 113.039"
        stroke="white"
        strokeWidth="0.832223"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.148 101.039C40.6031 101.039 41.7827 99.8594 41.7827 98.4043C41.7827 96.9491 40.6031 95.7695 39.148 95.7695C37.6929 95.7695 36.5133 96.9491 36.5133 98.4043C36.5133 99.8594 37.6929 101.039 39.148 101.039Z"
        fill="white"
      />
      <path
        d="M39.1481 95.7695V101.039"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.5133 98.4023H41.7827"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.2852 96.5391L41.0115 100.264"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.2852 100.264L41.0115 96.5391"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.1482 99.3755C39.6866 99.3755 40.1231 98.939 40.1231 98.4006C40.1231 97.8622 39.6866 97.4258 39.1482 97.4258C38.6098 97.4258 38.1734 97.8622 38.1734 98.4006C38.1734 98.939 38.6098 99.3755 39.1482 99.3755Z"
        fill="white"
      />
      <path
        d="M39.1482 98.9289C39.4392 98.9289 39.6752 98.693 39.6752 98.4019C39.6752 98.1109 39.4392 97.875 39.1482 97.875C38.8572 97.875 38.6213 98.1109 38.6213 98.4019C38.6213 98.693 38.8572 98.9289 39.1482 98.9289Z"
        fill="#979797"
      />
      <path
        d="M46.5699 105.615C46.9041 104.199 46.027 102.78 44.6108 102.445C43.1946 102.111 41.7756 102.988 41.4413 104.404C41.1071 105.821 41.9842 107.24 43.4004 107.574C44.8166 107.908 46.2356 107.031 46.5699 105.615Z"
        fill="white"
      />
      <path
        d="M44.0084 102.383V107.652"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.3736 105.016H46.643"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.1455 103.152L45.8717 106.879"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.1455 106.879L45.8717 103.152"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.0085 105.989C44.5469 105.989 44.9833 105.552 44.9833 105.014C44.9833 104.476 44.5469 104.039 44.0085 104.039C43.4701 104.039 43.0336 104.476 43.0336 105.014C43.0336 105.552 43.4701 105.989 44.0085 105.989Z"
        fill="white"
      />
      <path
        d="M44.0084 105.542C44.2995 105.542 44.5354 105.306 44.5354 105.015C44.5354 104.724 44.2995 104.488 44.0084 104.488C43.7174 104.488 43.4815 104.724 43.4815 105.015C43.4815 105.306 43.7174 105.542 44.0084 105.542Z"
        fill="#979797"
      />
      <path
        d="M34.3874 111.091C34.7216 109.675 33.8445 108.256 32.4283 107.922C31.0121 107.588 29.5931 108.465 29.2588 109.881C28.9246 111.297 29.8017 112.716 31.2179 113.051C32.6341 113.385 34.0531 112.508 34.3874 111.091Z"
        fill="white"
      />
      <path
        d="M31.8246 107.859V113.129"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.1902 110.496H34.4597"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.9617 108.633L33.688 112.359"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.9617 112.359L33.688 108.633"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.8247 111.469C32.3631 111.469 32.7995 111.033 32.7995 110.494C32.7995 109.956 32.3631 109.52 31.8247 109.52C31.2863 109.52 30.8498 109.956 30.8498 110.494C30.8498 111.033 31.2863 111.469 31.8247 111.469Z"
        fill="white"
      />
      <path
        d="M31.8247 111.023C32.1157 111.023 32.3516 110.787 32.3516 110.496C32.3516 110.205 32.1157 109.969 31.8247 109.969C31.5336 109.969 31.2977 110.205 31.2977 110.496C31.2977 110.787 31.5336 111.023 31.8247 111.023Z"
        fill="#979797"
      />
      <path
        d="M153.685 108.75V117.457"
        stroke="white"
        strokeWidth="0.832223"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M156.32 112.812L153.685 116.229"
        stroke="white"
        strokeWidth="0.832223"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M156.242 105.716C156.576 104.3 155.699 102.881 154.283 102.547C152.867 102.213 151.448 103.09 151.114 104.506C150.779 105.922 151.656 107.341 153.073 107.676C154.489 108.01 155.908 107.133 156.242 105.716Z"
        fill="white"
      />
      <path
        d="M153.685 102.484V107.754"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M151.05 105.117H156.319"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M151.821 103.254L155.548 106.979"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M151.821 106.979L155.548 103.254"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M153.685 106.094C154.223 106.094 154.66 105.658 154.66 105.119C154.66 104.581 154.223 104.145 153.685 104.145C153.146 104.145 152.71 104.581 152.71 105.119C152.71 105.658 153.146 106.094 153.685 106.094Z"
        fill="white"
      />
      <path
        d="M153.685 105.644C153.976 105.644 154.212 105.408 154.212 105.117C154.212 104.826 153.976 104.59 153.685 104.59C153.394 104.59 153.158 104.826 153.158 105.117C153.158 105.408 153.394 105.644 153.685 105.644Z"
        fill="#979797"
      />
      <path
        d="M160.408 112.25C161.437 111.221 161.437 109.553 160.408 108.524C159.379 107.495 157.711 107.495 156.682 108.524C155.653 109.553 155.653 111.221 156.682 112.25C157.711 113.279 159.379 113.279 160.408 112.25Z"
        fill="white"
      />
      <path
        d="M158.545 107.754V113.024"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M155.91 110.387H161.18"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M156.682 108.523L160.408 112.249"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M156.682 112.249L160.408 108.523"
        stroke="white"
        strokeWidth="0.475556"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M158.545 111.364C159.083 111.364 159.52 110.927 159.52 110.389C159.52 109.851 159.083 109.414 158.545 109.414C158.006 109.414 157.57 109.851 157.57 110.389C157.57 110.927 158.006 111.364 158.545 111.364Z"
        fill="white"
      />
      <path
        d="M158.545 110.913C158.836 110.913 159.072 110.677 159.072 110.386C159.072 110.095 158.836 109.859 158.545 109.859C158.254 109.859 158.018 110.095 158.018 110.386C158.018 110.677 158.254 110.913 158.545 110.913Z"
        fill="#979797"
      />
      <path
        d="M181 118H158C158 115.41 161.067 113.311 164.851 113.311C166.104 113.301 167.346 113.547 168.505 114.034C169.333 112.803 170.525 111.875 171.906 111.386C173.287 110.897 174.786 110.872 176.182 111.315C177.578 111.758 178.798 112.646 179.665 113.849C180.532 115.052 181 116.506 181 118Z"
        fill="#979797"
      />
      <path
        d="M64.6722 25.698C71.7685 25.698 77.5212 19.9453 77.5212 12.849C77.5212 5.7527 71.7685 0 64.6722 0C57.5758 0 51.8231 5.7527 51.8231 12.849C51.8231 19.9453 57.5758 25.698 64.6722 25.698Z"
        fill="#979797"
      />
      <path
        d="M65.9029 18.0828H31.2355C31.2355 15.4067 34.3934 13.2368 38.2928 13.2368C39.1356 13.235 39.9751 13.341 40.7911 13.552C41.4414 12.7124 42.2748 12.0324 43.2278 11.5637C44.1807 11.0951 45.2281 10.8501 46.2901 10.8477C49.6287 10.8477 52.4253 13.2274 53.1592 16.4229C54.4427 15.6372 56.5129 15.0162 58.8484 15.0162C62.7449 15.0162 65.9029 16.7447 65.9029 18.0828Z"
        fill="#D7D9DB"
      />
      <path
        d="M114.846 6.73245H86.3346C86.3346 3.02501 89.0182 0.0195312 92.3295 0.0195312C94.219 0.0195312 95.9052 0.998146 97.0024 2.52817C97.6956 2.33266 98.4125 2.23448 99.1328 2.23647C101.552 2.23647 103.637 3.31106 104.584 4.85897C105.671 4.29438 107.182 3.88694 108.852 3.88694C112.164 3.88694 114.846 5.49036 114.846 6.73245Z"
        fill="#D7D9DB"
      />
    </svg>
  );
}
